import React from 'react';

import { LessonPreviewLayout } from 'components/Layout';
import { PluginPreviewPage } from './components/PluginPreviewPage';
import { WebPreviewPage } from './components/WebPreviewPage';

const ConnectionQuizPreviewPage = ({
  rootRef,
  containerRef,
  leftItemsRef,
  rightItemsRef,
  lineDrawing,
  linesValidated,
  leftItems,
  rightItems,
  lines,
  correctLinesIds,
  startLinePosition,
  lesson,
  onProcessDrawing,
  onItemClick,
  onTryAgainClick,
  onRestartLessonClick,
  previewType,
  setPreviewType,
  isTestMode,
  setTestMode,
  onChangePreviewType,
  ...props
}: {
  rootRef: any;
  containerRef: any;
  leftItemsRef: any;
  rightItemsRef: any;
  lineDrawing: any;
  linesValidated: any;
  leftItems: any;
  rightItems: any;
  lines: any;
  correctLinesIds: any;
  startLinePosition: any;
  lesson: any;
  onProcessDrawing: any;
  onItemClick: any;
  onTryAgainClick: any;
  onRestartLessonClick: any;
  previewType: any;
  setPreviewType: any;
  isTestMode: any;
  setTestMode: any;
  onChangePreviewType: any;
  props: any;
}) => (
  <LessonPreviewLayout
    setPreviewType={onChangePreviewType}
    setTestMode={setTestMode}
  >
    {previewType === 'Plugin' ? (
      <PluginPreviewPage
        {...props}
        lineDrawing={lineDrawing}
        linesValidated={linesValidated}
        containerRef={containerRef}
        leftItemsRef={leftItemsRef}
        rightItemsRef={rightItemsRef}
        rootRef={rootRef}
        leftItems={leftItems}
        rightItems={rightItems}
        lines={lines}
        correctLinesIds={correctLinesIds}
        lesson={lesson}
        startLinePosition={startLinePosition}
        onProcessDrawing={onProcessDrawing}
        onItemClick={onItemClick}
        onTryAgainClick={onTryAgainClick}
        onRestartLessonClick={onRestartLessonClick}
        isTestMode={isTestMode}
      />
    ) : (
      <WebPreviewPage
        {...props}
        lineDrawing={lineDrawing}
        linesValidated={linesValidated}
        containerRef={containerRef}
        leftItemsRef={leftItemsRef}
        rightItemsRef={rightItemsRef}
        rootRef={rootRef}
        leftItems={leftItems}
        rightItems={rightItems}
        lines={lines}
        correctLinesIds={correctLinesIds}
        lesson={lesson}
        startLinePosition={startLinePosition}
        onProcessDrawing={onProcessDrawing}
        onItemClick={onItemClick}
        onTryAgainClick={onTryAgainClick}
        onRestartLessonClick={onRestartLessonClick}
        isTestMode={isTestMode}
      />
    )}
  </LessonPreviewLayout>
);

export default React.memo(ConnectionQuizPreviewPage) as any;
